const COUNTRY_DATA: Record<string, { name: string; flag: string }> = {
  US: { name: 'United States', flag: '\u{1F1FA}\u{1F1F8}' },
  GB: { name: 'United Kingdom', flag: '\u{1F1EC}\u{1F1E7}' },
  CA: { name: 'Canada', flag: '\u{1F1E8}\u{1F1E6}' },
  AU: { name: 'Australia', flag: '\u{1F1E6}\u{1F1FA}' },
  DE: { name: 'Germany', flag: '\u{1F1E9}\u{1F1EA}' },
  FR: { name: 'France', flag: '\u{1F1EB}\u{1F1F7}' },
  JP: { name: 'Japan', flag: '\u{1F1EF}\u{1F1F5}' },
  CN: { name: 'China', flag: '\u{1F1E8}\u{1F1F3}' },
  KR: { name: 'South Korea', flag: '\u{1F1F0}\u{1F1F7}' },
  IN: { name: 'India', flag: '\u{1F1EE}\u{1F1F3}' },
  BR: { name: 'Brazil', flag: '\u{1F1E7}\u{1F1F7}' },
  MX: { name: 'Mexico', flag: '\u{1F1F2}\u{1F1FD}' },
  ES: { name: 'Spain', flag: '\u{1F1EA}\u{1F1F8}' },
  IT: { name: 'Italy', flag: '\u{1F1EE}\u{1F1F9}' },
  NL: { name: 'Netherlands', flag: '\u{1F1F3}\u{1F1F1}' },
  SE: { name: 'Sweden', flag: '\u{1F1F8}\u{1F1EA}' },
  NO: { name: 'Norway', flag: '\u{1F1F3}\u{1F1F4}' },
  DK: { name: 'Denmark', flag: '\u{1F1E9}\u{1F1F0}' },
  FI: { name: 'Finland', flag: '\u{1F1EB}\u{1F1EE}' },
  CH: { name: 'Switzerland', flag: '\u{1F1E8}\u{1F1ED}' },
  AT: { name: 'Austria', flag: '\u{1F1E6}\u{1F1F9}' },
  BE: { name: 'Belgium', flag: '\u{1F1E7}\u{1F1EA}' },
  PT: { name: 'Portugal', flag: '\u{1F1F5}\u{1F1F9}' },
  IE: { name: 'Ireland', flag: '\u{1F1EE}\u{1F1EA}' },
  NZ: { name: 'New Zealand', flag: '\u{1F1F3}\u{1F1FF}' },
  SG: { name: 'Singapore', flag: '\u{1F1F8}\u{1F1EC}' },
  HK: { name: 'Hong Kong', flag: '\u{1F1ED}\u{1F1F0}' },
  TW: { name: 'Taiwan', flag: '\u{1F1F9}\u{1F1FC}' },
  TH: { name: 'Thailand', flag: '\u{1F1F9}\u{1F1ED}' },
  VN: { name: 'Vietnam', flag: '\u{1F1FB}\u{1F1F3}' },
  PH: { name: 'Philippines', flag: '\u{1F1F5}\u{1F1ED}' },
  ID: { name: 'Indonesia', flag: '\u{1F1EE}\u{1F1E9}' },
  MY: { name: 'Malaysia', flag: '\u{1F1F2}\u{1F1FE}' },
  IL: { name: 'Israel', flag: '\u{1F1EE}\u{1F1F1}' },
  AE: { name: 'UAE', flag: '\u{1F1E6}\u{1F1EA}' },
  SA: { name: 'Saudi Arabia', flag: '\u{1F1F8}\u{1F1E6}' },
  ZA: { name: 'South Africa', flag: '\u{1F1FF}\u{1F1E6}' },
  NG: { name: 'Nigeria', flag: '\u{1F1F3}\u{1F1EC}' },
  KE: { name: 'Kenya', flag: '\u{1F1F0}\u{1F1EA}' },
  EG: { name: 'Egypt', flag: '\u{1F1EA}\u{1F1EC}' },
  PL: { name: 'Poland', flag: '\u{1F1F5}\u{1F1F1}' },
  CZ: { name: 'Czech Republic', flag: '\u{1F1E8}\u{1F1FF}' },
  RO: { name: 'Romania', flag: '\u{1F1F7}\u{1F1F4}' },
  GR: { name: 'Greece', flag: '\u{1F1EC}\u{1F1F7}' },
  TR: { name: 'Turkey', flag: '\u{1F1F9}\u{1F1F7}' },
  AR: { name: 'Argentina', flag: '\u{1F1E6}\u{1F1F7}' },
  CL: { name: 'Chile', flag: '\u{1F1E8}\u{1F1F1}' },
  CO: { name: 'Colombia', flag: '\u{1F1E8}\u{1F1F4}' },
  PE: { name: 'Peru', flag: '\u{1F1F5}\u{1F1EA}' },
  RU: { name: 'Russia', flag: '\u{1F1F7}\u{1F1FA}' },
  UA: { name: 'Ukraine', flag: '\u{1F1FA}\u{1F1E6}' },
};

const COUNTRY_NAME_TO_CODE: Record<string, string> = {};
Object.entries(COUNTRY_DATA).forEach(([code, { name }]) => {
  COUNTRY_NAME_TO_CODE[name.toLowerCase()] = code;
});

const EXTRA_NAMES: Record<string, string> = {
  'usa': 'US',
  'u.s.a.': 'US',
  'u.s.': 'US',
  'united states of america': 'US',
  'uk': 'GB',
  'u.k.': 'GB',
  'england': 'GB',
  'scotland': 'GB',
  'wales': 'GB',
  'northern ireland': 'GB',
  'great britain': 'GB',
  'korea': 'KR',
  'south korea': 'KR',
  'republic of korea': 'KR',
  'holland': 'NL',
  'the netherlands': 'NL',
  'czechia': 'CZ',
  'türkiye': 'TR',
  'turkiye': 'TR',
  'uae': 'AE',
  'united arab emirates': 'AE',
};

Object.entries(EXTRA_NAMES).forEach(([name, code]) => {
  COUNTRY_NAME_TO_CODE[name.toLowerCase()] = code;
});

const US_STATES: Record<string, boolean> = {
  'AL': true, 'AK': true, 'AZ': true, 'AR': true, 'CA': true,
  'CO': true, 'CT': true, 'DE': true, 'FL': true, 'GA': true,
  'HI': true, 'ID': true, 'IL': true, 'IN': true, 'IA': true,
  'KS': true, 'KY': true, 'LA': true, 'ME': true, 'MD': true,
  'MA': true, 'MI': true, 'MN': true, 'MS': true, 'MO': true,
  'MT': true, 'NE': true, 'NV': true, 'NH': true, 'NJ': true,
  'NM': true, 'NY': true, 'NC': true, 'ND': true, 'OH': true,
  'OK': true, 'OR': true, 'PA': true, 'RI': true, 'SC': true,
  'SD': true, 'TN': true, 'TX': true, 'UT': true, 'VT': true,
  'VA': true, 'WA': true, 'WV': true, 'WI': true, 'WY': true,
  'DC': true,
};

const CANADIAN_PROVINCES: Record<string, boolean> = {
  'AB': true, 'BC': true, 'MB': true, 'NB': true, 'NL': true,
  'NS': true, 'NT': true, 'NU': true, 'ON': true, 'PE': true,
  'QC': true, 'SK': true, 'YT': true,
};

export interface CountryInfo {
  code: string;
  name: string;
  flag: string;
}

export function extractCountryFromLocation(location: string | undefined): CountryInfo | null {
  if (!location || location.trim().length === 0) return null;

  const cleaned = location.trim();
  const parts = cleaned.split(',').map(p => p.trim());
  const lastPart = parts[parts.length - 1];

  if (lastPart.length === 2 && COUNTRY_DATA[lastPart.toUpperCase()]) {
    const code = lastPart.toUpperCase();
    return { code, ...COUNTRY_DATA[code] };
  }

  const lastLower = lastPart.toLowerCase();
  const codeFromName = COUNTRY_NAME_TO_CODE[lastLower];
  if (codeFromName && COUNTRY_DATA[codeFromName]) {
    return { code: codeFromName, ...COUNTRY_DATA[codeFromName] };
  }

  if (parts.length >= 2) {
    const secondLast = parts[parts.length - 2]?.trim();
    const secondLastUpper = secondLast?.toUpperCase();

    if (secondLastUpper && US_STATES[secondLastUpper]) {
      return { code: 'US', ...COUNTRY_DATA['US'] };
    }
    if (secondLastUpper && CANADIAN_PROVINCES[secondLastUpper]) {
      return { code: 'CA', ...COUNTRY_DATA['CA'] };
    }

    const lastUpper = lastPart.toUpperCase();
    if (US_STATES[lastUpper]) {
      return { code: 'US', ...COUNTRY_DATA['US'] };
    }
    if (CANADIAN_PROVINCES[lastUpper]) {
      return { code: 'CA', ...COUNTRY_DATA['CA'] };
    }
  }

  if (parts.length === 1 && lastPart.length === 2) {
    const upper = lastPart.toUpperCase();
    if (US_STATES[upper]) {
      return { code: 'US', ...COUNTRY_DATA['US'] };
    }
  }

  for (const [name, code] of Object.entries(COUNTRY_NAME_TO_CODE)) {
    if (cleaned.toLowerCase().includes(name)) {
      return { code, ...COUNTRY_DATA[code] };
    }
  }

  return null;
}

function decodeHtmlEntities(text: string): string {
  return text
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'")
    .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(parseInt(code, 10)))
    .replace(/&[a-z]+;/g, '');
}

export function extractCountryFromEvent(event: { location?: string; description?: string }): CountryInfo | null {
  if (event.location) {
    const decoded = decodeHtmlEntities(event.location);
    const fromLocation = extractCountryFromLocation(decoded);
    if (fromLocation) return fromLocation;
  }

  if (event.description) {
    const locationMatch = event.description.match(/Location:\s*(.+?)(?:\\n|\n|$)/);
    if (locationMatch) {
      const decoded = decodeHtmlEntities(locationMatch[1]);
      const fromDesc = extractCountryFromLocation(decoded);
      if (fromDesc) return fromDesc;
    }
  }

  return null;
}

export function getCountryData(code: string): CountryInfo | null {
  const data = COUNTRY_DATA[code];
  if (!data) return null;
  return { code, ...data };
}

export function getAllCountryData(): Record<string, { name: string; flag: string }> {
  return COUNTRY_DATA;
}
